import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const ArrayGalleryDesignSettings = {
  // dimensions
  'array-gallery-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'array-gallery-design-modal-width': {
    phone: ['90%'],
    'phone-landscape': ['50%'],
    tablet: ['80%'],
    'tablet-landscape': ['70%'],
    desktop: ['50%'],
    tv: ['50%'],
  },

  // alignment
  'array-gallery-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'array-gallery-design-comp-title-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  // aspect ratio
  'array-gallery-design-aspect-ratio': {
    phone: '4:3',
    'phone-landscape': '4:3',
    tablet: '4:3',
    'tablet-landscape': '4:3',
    desktop: '4:3',
    tv: '4:3',
  },

  // spacing
  'array-gallery-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'array-gallery-design-headline-margin': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },

  // // Layout
  'array-gallery-data-num-array-items': {
    phone: 10,
    'phone-landscape': 10,
    tablet: 10,
    'tablet-landscape': 10,
    desktop: 10,
    tv: 10,
  },
  'array-gallery-design-num-cols': {
    phone: 2,
    'phone-landscape': 2,
    tablet: 2,
    'tablet-landscape': 3,
    desktop: 4,
    tv: 4,
  },

  // (nested) typography
  'array-gallery-design-typography': {
    'array-gallery-design-headline-typography': {
      phone: getDefaultTypography('headline-small'),
      'phone-landscape': getDefaultTypography('headline-small'),
      tablet: getDefaultTypography('headline-small'),
      'tablet-landscape': getDefaultTypography('headline-small'),
      desktop: getDefaultTypography('headline-small'),
      tv: getDefaultTypography('headline-small'),
    },
    'array-gallery-design-caption-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
}
